module.exports = __webpack_public_path__ + "static/media/16.1c91d4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/16.png
// module id = 975
// module chunks = 0